



































import { defineComponent, type PropType } from "vue-demi";
import type {
  PageData,
  PageDataPropUnion,
} from "@constructor/shared-entity/type";
import MPGroup from "./MPGroup/MPGroup.vue";

export default defineComponent({
  name: "MPCategoryGrid",
  components: {
    MPGroup,
  },
  props: {
    prop: {
      type: Array as PropType<PageDataPropUnion[]>,
      default: () => [],
    },
    data: {
      type: Object as PropType<PageData>,
      required: true,
    },
  },
  data() {
    return {
      activeStories: false,
    };
  },
});
